import { FC } from "react";

interface BlogPostImageProps {
  title: string;
  backgroundImage?: string;
  icon?: React.ReactNode;
  className?: string;
}

const BlogPostImage: FC<BlogPostImageProps> = ({
  title,
  backgroundImage = "/placeholder.svg",
  icon,
  className = ""
}) => {
  return (
    <div className={`relative w-full h-full overflow-hidden ${className}`}>
      {/* Background Image */}
      <img
        src={backgroundImage}
        alt={title}
        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
      />

      {/* Overlay sutil no hover */}
      <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

      {/* Ícone no canto inferior (opcional) */}
      {icon && (
        <div className="absolute bottom-4 right-4 p-3 rounded-lg bg-primary/90 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="text-primary-foreground w-6 h-6 flex items-center justify-center">
            {icon}
          </div>
        </div>
      )}
    </div>
  );
};

export default BlogPostImage;
